"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductWithInventoryData = void 0;
const responses_1 = require("../../sales-order/responses");
const inventory_data_response_1 = require("./inventory-data.response");
class ProductWithInventoryData {
}
exports.ProductWithInventoryData = ProductWithInventoryData;
//# sourceMappingURL=product-with-inventory-data.response.js.map